window.pointsQuery = (function ($) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            partnerActivity: '#partner-activity',
            partnerActivityContainer: '#partner-activity-containier',
            clubActivity: '#club-activity',
            clubActivityContainer: '#club-activity-container',
            vitalityActivity: '#vitality-activity',
            memberNames: '#member-activity',
            datePicker: '#activity-date',
            comments: '#member-comments',
            submitQuery: '#submit-query',
            activityError: '#activity-error',
            memberError: '#member-error',
            commentsError: '#comments-error',
            partnerError: '#partner-error',
            clubError: '#club-error',
            monthsDateErrorLabel: '#date-error-sixmonths',
            futureDateErrorLabel: '#date-error-future',
            lessThanFourWeeksDateErrorLabel: '#date-error-lessthan-fourweeks',
            dateError: '#date-error',
            activityLabel: '#activity-label',
            memberLabel: '#member-label',
            commentsLabel: '#comments-label',
            partnerLabel: '#partner-label',
            clubLabel: '#club-label',
            dateLabel: '#date-label',
            selectedValue: '#vitality-activity option:selected',
            selectedMember: '#member-activity option:selected',
            selectedPartnerValue: '#partner-activity option:selected',
            clubPartnerValue: '#club-activity option:selected',
            thanksModal: '.vds-notification--success',
            notificationAlert: '.vds-notification--alert',
            successReferenceNo: '#success-reference-no'
        },
        gymPartners: [],
        state: {
            activityValue: 'FASS'
        },
        urls: {
            errorPage: '/error/error-page'
        },
        helpers: {
            redirect: function (url) {
                window.location.replace(url);
            }
        },
        func: {
            init: function () {
                self.func.loadValues();
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.submitQuery).on('click', self.func.clickEvent.submitQuery);
                $(self.elements.vitalityActivity).on('change', self.func.clickEvent.selectActivity);
                $(self.elements.partnerActivity).on('change', self.func.clickEvent.selectPartnerActivity);
                $(self.elements.comments).on('keypress', self.func.clickEvent.changeComments);
                $(self.elements.memberNames).on('change', self.func.clickEvent.changeMemberActivity);
                $(self.elements.datePicker).on('change', self.func.clickEvent.changeDatePicker);
                $(self.elements.clubActivity).on('change', self.func.clickEvent.changeClubActivity);
            },
            loadValues: function () {
                $(self.elements.clubActivityContainer).hide();
                $(self.elements.partnerActivityContainer).hide();
                $(self.elements.activityError).hide();
                $(self.elements.memberError).hide();
                $(self.elements.commentsError).hide();
                $(self.elements.partnerError).hide();
                $(self.elements.clubError).hide();
                self.func.hideDateError();
                self.func.hideNotifications();
            },
            redirectToErrorPage: function () {
                self.func.clickEvent.pointsQueryGtmEvents('failure');
                self.helpers.redirect(self.urls.errorPage);
            },
            validateSelectedValue: function () {
                if ($(self.elements.activityError).is(':visible')) {
                    return false;
                } else if ($(self.elements.selectedValue).val() === '') {
                    $(self.elements.activityError).show();
                    $(self.elements.activityLabel).hide();
                    return false;
                } else {
                    $(self.elements.activityError).hide();
                    $(self.elements.activityLabel).show();
                    return true;
                }
            },
            validateSelectedMember: function () {
                if ($(self.elements.memberError).is(':visible')) {
                    return false;
                } else if ($(self.elements.selectedMember).val() === '') {
                    $(self.elements.memberError).show();
                    $(self.elements.memberLabel).hide();

                    return false;
                } else {
                    $(self.elements.memberError).hide();
                    $(self.elements.memberLabel).show();
                    return true;
                }
            },
            validateComments: function () {
                const specialCharacterRegex = /^[^%*&@#$^+=]+$/g;
                if ($(self.elements.commentsError).is(':visible')) {
                    return false;
                } else if ($(self.elements.comments).val() === ''
                    || !(specialCharacterRegex.test($(self.elements.comments).val()))) {
                    $(self.elements.commentsError).show();
                    $(self.elements.commentsLabel).hide();

                    return false
                } else {
                    $(self.elements.commentsError).hide();
                    $(self.elements.commentsLabel).show();
                    return true;
                }
            },
            hideDateError: function () {
                $(self.elements.dateError).hide();
                $(self.elements.futureDateErrorLabel).hide();
                $(self.elements.monthsDateErrorLabel).hide();
                $(self.elements.lessThanFourWeeksDateErrorLabel).hide();
            },
            validateDatePicker: function () {

                if ($(self.elements.datePicker).val() === '') {
                    $(self.elements.dateError).show();
                    $(self.elements.dateLabel).hide();

                    return false;
                } else if (!self.func.clickEvent.checkVitalityDays()) {
                    return false;
                } else {
                    $(self.elements.dateError).hide();
                    $(self.elements.dateLabel).show();
                    return true;
                }
            },
            validatePartnerActivity: function () {
                if ($(self.elements.partnerError).is(':visible')) {
                    return false;
                } else if ($(self.elements.partnerActivity).is(':visible')
                    && $(self.elements.selectedPartnerValue).val() === '') {
                    $(self.elements.partnerError).show();
                    $(self.elements.partnerLabel).hide();

                    return false;
                } else {
                    $(self.elements.partnerError).hide();
                    $(self.elements.partnerLabel).show();

                    return true;
                }
            },
            validateClubActivity: function () {
                if ($(self.elements.clubError).is(':visible')) {
                    return false;
                } else if ($(self.elements.clubActivity).is(':visible')
                    && $(self.elements.clubPartnerValue).val() === '') {
                    $(self.elements.clubError).show();
                    $(self.elements.clubLabel).hide();

                    return false
                } else {
                    $(self.elements.clubError).hide();
                    $(self.elements.clubLabel).show();

                    return true;
                }
            },
            validateActivity: function () {
                let isValid = true;

                if (!(self.func.validatePartnerActivity())) {
                    isValid = false;
                }

                if (!self.func.validateClubActivity()) {
                    isValid = false;
                }

                return isValid;
            },
            validations: function () {
                let isValid = true;
                if (!self.func.validateSelectedValue()) {
                    isValid = false;
                }
                if (!self.func.validateSelectedMember()) {
                    isValid = false;
                }
                if (!self.func.validateComments()) {
                    isValid = false;
                }
                if (!self.func.validateDatePicker()) {
                    isValid = false;
                }
                if (!self.func.validateActivity()) {
                    isValid = false;
                }
                return isValid;
            },
            loadGymPartnersSuccess: function (result) {
                $(self.elements.clubActivity).empty();
                $(self.elements.partnerActivity).empty();
                $(self.elements.clubActivity).empty();
                let options = '<option value="">'
                    + $(self.elements.partnerActivity).data('partnerdefaultvalue') + '</option>';
                $(self.elements.partnerActivity).append(options);
                options = '<option value="">'
                    + $(self.elements.clubActivity).data('clubdefaultvalue') + '</option>';
                $(self.elements.clubActivity).append(options);
                self.gymPartners = result.gymPartnerList;
                for (let k = 0; k < self.gymPartners.length; k++) {
                    const newOption = $('<option value="' + self.gymPartners[k].partnerEntityNumber
                        + '">' + self.gymPartners[k].partnerName + '</option>');
                    $(self.elements.partnerActivity).append(newOption);
                }
            },
            loadPartnerList: function (partnerList) {
                for (let j = 0; j < partnerList.length; j++) {
                    if (partnerList[j].partnerEntityNumber === $(self.elements.selectedPartnerValue).val()) {
                        const partnerBranchList = partnerList[j].gymPartnerBranchList;
                        self.func.loadPartnerBranchList(partnerBranchList);
                    }
                }
            },
            loadPartnerBranchList: function (partnerBranchList) {
                for (let k = 0; k < partnerBranchList.length; k++) {
                    self.func.clickEvent.clubNames.push(partnerBranchList[k]);
                    const newOption = $('<option value="' + partnerBranchList[k].partnerBranchEntityNumber
                        + '">' + partnerBranchList[k].partnerBranchName + '</option>');
                    $(self.elements.clubActivity).append(newOption);
                }
            },
            hideNotifications: function () {
                $(self.elements.thanksModal).hide();
                $(self.elements.notificationAlert).hide();
            },
            clickEvent:
                {
                    partnerEntityNumber: '',
                    clubNames: [],
                    partnerBranchEntityNumber: '',

                    submitQuery: function () {
                        self.func.hideNotifications();

                        if (self.func.validations()) {
                            const data = {
                                'EntityId': $(self.elements.selectedMember).val(),
                                'ActivityMnemonic': $(self.elements.selectedValue).val(),
                                'ActivityDate': $(self.elements.datePicker).val(),
                                'Comments': $(self.elements.comments).val(),
                                'PartnerName': $(self.elements.selectedPartnerValue).text(),
                                'PartnerEntityNumber': $(self.elements.selectedPartnerValue).val(),
                                'PartnerBranchName': $(self.elements.clubPartnerValue).text(),
                                'PartnerBranchEntityNumber': $(self.elements.clubPartnerValue).val()
                            };

                            $.ajax({
                                type: 'GET',
                                url: '/api/sitecore/PointsQuery/SubmitRequest',
                                contentType: 'application/json; charset=utf-8',
                                data: data,
                                dataType: 'json',
                                success: self.func.clickEvent.pointsQuerySuccess,
                                error: self.func.redirectToErrorPage
                            })
                        }
                    },
                    pointsQueryGtmEvents: function (actionResult) {
                        const pageTitle = $(document).attr('title');
                        window.dataLayer.push({
                            'event': 'ga_event',
                            'ga_event': {
                                'category': 'form submission',
                                'action': actionResult,
                                'label': pageTitle + ' form',
                                'value': 0,
                                'nonInteraction': 0
                            }
                        });
                    },
                    pointsQuerySuccess: function (result) {
                        if (result.isSuccess) {
                            $(self.elements.vitalityActivity).val('');
                            $(self.elements.memberNames).val('');
                            $(self.elements.partnerActivity).val('');
                            $(self.elements.partnerActivityContainer).hide();
                            $(self.elements.clubActivity).val('');
                            $(self.elements.clubActivityContainer).hide();
                            $(self.elements.datePicker).val();
                            $(self.elements.comments).val('');
                            $(self.elements.successReferenceNo).text(result.queryReferenceId);
                            $(self.elements.thanksModal).show();
                            self.func.clickEvent.pointsQueryGtmEvents('success');
                        } else {
                            $(self.elements.notificationAlert).show();
                            self.func.clickEvent.pointsQueryGtmEvents('failure');
                        }
                    },
                    selectPartnerActivity: function () {
                        self.func.clickEvent.changePartnerActivity();
                        $(self.elements.clubActivity).empty();
                        const options = '<option value="">'
                            + $(self.elements.clubActivity).data('clubdefaultvalue') + '</option>';
                        $(self.elements.clubActivity).append(options);
                        self.func.loadPartnerList(self.gymPartners);
                        self.func.hideNotifications();
                    },
                    selectActivity: function () {
                        if ($(self.elements.selectedValue).val() !== '') {
                            $(self.elements.activityError).hide();
                            $(self.elements.activityLabel).show();
                        }
                        self.func.clickEvent.checkForGymFitness();
                        self.func.hideNotifications();
                    },
                    changeComments: function () {
                        if ($(self.elements.comments).val() !== '') {
                            $(self.elements.commentsError).hide();
                            $(self.elements.commentsLabel).show();
                        }

                        self.func.hideNotifications();
                    },
                    changeMemberActivity: function () {
                        if ($(self.elements.memberNames).val() !== '') {
                            $(self.elements.memberError).hide();
                            $(self.elements.memberLabel).show();
                        }
                        self.func.clickEvent.checkForGymFitness();
                        self.func.hideNotifications();
                    },
                    checkForGymFitness: function () {
                        const strUser = $(self.elements.selectedValue).val();
                        if (strUser === self.state.activityValue && ($(self.elements.memberNames).val() !== '')) {
                            self.func.clickEvent.loadGymPartners();
                            $(self.elements.clubActivityContainer).show();
                            $(self.elements.partnerActivityContainer).show();
                        } else {
                            $(self.elements.clubActivityContainer).hide();
                            $(self.elements.partnerActivityContainer).hide();
                        }
                    },
                    changeDatePicker: function () {
                        const date = $(self.elements.datePicker).val();
                        if (date !== '') {
                            $(self.elements.dateError).hide();
                            $(self.elements.dateLabel).show();
                        }
                        self.func.clickEvent.checkVitalityDays();
                        self.func.hideNotifications();
                    },
                    loadGymPartners: function () {
                        $.ajax({
                            type: 'GET',
                            url: '/api/sitecore/PointsQuery/ClubNames?entityNumber=' + $(self.elements.memberNames).val(),
                            contentType: 'application/json',
                            dataType: 'json',
                            success: function (result) {
                                self.func.loadGymPartnersSuccess(result);
                            },
                        })
                        self.func.clickEvent.changePartnerActivity();
                    },
                    changePartnerActivity: function () {
                        if ($(self.elements.PartnerActivity).val() !== '') {
                            $(self.elements.partnerError).hide();
                            $(self.elements.partnerLabel).show();
                        }
                    },
                    changeClubActivity: function () {
                        if ($(self.elements.clubActivity).val() !== '') {
                            $(self.elements.clubError).hide();
                            $(self.elements.clubLabel).show();
                        }

                        const clubs = self.func.clickEvent.clubNames;
                        for (let i = 0; i < clubs.length; i++) {
                            if (clubs[i].partnerBranchName === $(self.elements.clubActivity).val()) {
                                self.func.clickEvent.partnerBranchEntityNumber = clubs[i].partnerBranchEntityNumber;
                            }
                        }
                    },
                    checkVitalityDays: function () {
                        self.func.hideDateError();
                        $(self.elements.dateLabel).hide();
                        const date = $(self.elements.datePicker).val().split('-');
                        const day = date[2];
                        const month = date[1];
                        const year = date[0];
                        const todayDate = new Date();
                        const vitalityActivityDate = new Date(year, month - 1, day);
                        let isValid = false;
                        const diff = Math.floor((todayDate - vitalityActivityDate) / (24 * 3600 * 1000));
                        if (diff < 0) {
                            $(self.elements.futureDateErrorLabel).show();
                        } else if (diff <= 28) {
                            $(self.elements.lessThanFourWeeksDateErrorLabel).show();
                        } else if (diff >= 182 || (year % 4 !== 0 && diff > 183 && month < 6)) {
                            $(self.elements.monthsDateErrorLabel).show();
                        } else {
                            $(self.elements.dateLabel).show();

                            isValid = true;
                        }

                        return isValid;
                    }
                }
        }
    };

    return {
        Init: self.func.init
    };
})(window.jQuery);

$('document').ready(function () {
    if ('pointsquery' === $('#page-data').data('feature')) {
        window.pointsQuery.Init();
    }
});
